<template>
  <div
    class="adsContainer"
    :style="{ height: isQuickStart ? 'calc(100vh - 48px)' : '100vh' }"
    :class="{ 'mt-12': isQuickStart }"
  >
    <v-row class="adsContent justify-space-between" :class="{ mobileAdsContent: isMobileSized }">
      <v-col
        class="d-flex px-0"
        :class="{
          'mt-16': isMobileSized,
          desktopAdsTextContent: !isMobileSized,
        }"
        style="position:relative;"
        :cols="isMobileSized ? 12 : ''"
        :style="isMobileSized ? '' : 'height:100%; max-width: 41.6666666667%;'"
      >
        <div>
          <StepIcons :currentView="'ads'" :isMobileSized="isMobileSized" />
          <v-row no-gutters :style="isMobileSized ? '' : 'height:75vh'">
            <div>
              <div
                class="text-h4 font-weight-bold pl-6 adsTitle"
                :class="{ mobileTitle: isMobileSized }"
              >
                Your Ads
              </div>
              <div
                class="adsTextContainer"
                :class="isMobileSized ? 'off-bottom' : ''"
                ref="adsTextContainer"
              >
                <div
                  v-if="isQuickStart"
                  class="adsText px-6"
                  style="height: calc(100vh - 270px); overflow: auto;"
                  @scroll="setShadows"
                >
                  <p
                    class="largeDescriptionText"
                    :class="isMobileSized ? 'mobileDescriptionText mt-2' : 'mt-6'"
                  >
                    <b>Click on an ad to edit it.</b>
                    Be sure to do the following:
                  </p>
                  <ul
                    class="largeDescriptionText"
                    :class="{ mobileDescriptionText: isMobileSized }"
                  >
                    <li>upload your logo (required)</li>
                    <li
                      >replace the placeholder text/promotional messaging with your own (optional,
                      but recommended)</li
                    >
                    <li
                      >replace the placeholder image with your own relevant image (optional, but
                      recommended)</li
                    >
                    <li
                      >if you want your ad to go to a specific landing page when clicked, enter that
                      url by clicking on the link icon in the ad header (optional, but recommended.
                      If no link provided, the ad will default to the advertiser url which you'll
                      give us in the next step)</li
                    >
                    <li v-if="mode === 'dynamic'"
                      >import your products so that the placeholder products in the ads will display
                      your products instead
                    </li>
                  </ul>
                </div>
                <div
                  v-else
                  class="adsText px-6"
                  ref="adsText"
                  :style="{
                    overflow: 'auto',
                    height: isMobileSized ? `calc(55vh - 182px)` : `calc(100vh - 270px)`,
                  }"
                  @scroll="setShadows"
                >
                  <p
                    class="largeDescriptionText"
                    :class="isMobileSized ? 'mobileDescriptionText mt-2' : 'mt-6'"
                  >
                    Everyone starts off with freemium ads at Adacado. These ads include a "Freemium
                    Ads by Adacado" watermark. This lets us help you get started quickly, easily,
                    and at no cost. You can remove this watermark after getting started if you no
                    longer want to use freemium ads. Or, you can simply continue to run your
                    freemium ads as long as you'd like.
                  </p>
                  <p
                    class="largeDescriptionText"
                    :class="isMobileSized ? 'mobileDescriptionText mt-2' : 'mt-6'"
                  >
                    While you can make ads of any size/format with Adacado, freemium ads are
                    currently only available in these two popular ad formats: 300x250 and 728x90.
                  </p>
                  <p
                    class="largeDescriptionText"
                    :class="isMobileSized ? 'mobileDescriptionText mt-2' : 'mt-6'"
                  >
                    <b>Click on an ad to edit it.</b>
                    Be sure to do the following:
                  </p>
                  <ul
                    class="largeDescriptionText"
                    :class="{ mobileDescriptionText: isMobileSized }"
                  >
                    <li>upload your logo (required)</li>
                    <li
                      >replace the placeholder text/promotional messaging with your own (optional,
                      but recommended)</li
                    >
                    <li
                      >replace the placeholder image with your own relevant image (optional, but
                      recommended)</li
                    >
                    <li
                      >if you want your ad to go to a specific landing page when clicked, enter that
                      url by clicking on the link icon in the ad header (optional, but recommended.
                      If no link provided, the ad will default to the advertiser url which you'll
                      give us in the next step)</li
                    >
                    <li v-if="mode === 'dynamic'"
                      >import your products so that the placeholder products in the ads will display
                      your products instead
                    </li>
                  </ul>
                </div>
                <div class="shadow shadow-top" aria-hidden="true"></div>
                <div class="shadow shadow-bottom" aria-hidden="true"></div>
              </div>
            </div>
          </v-row>
        </div>
      </v-col>
      <v-col class="d-flex py-0 editorArea" :class="{ mobileEditorArea: isMobileSized }">
        <div :style="isMobileSized ? 'width: 100vw' : 'width: 100%'">
          <div class="d-flex mb-4 mt-4" style="width: 100%; position: relative;">
            <v-btn
              v-if="mode === 'dynamic'"
              color="green"
              :small="!isMobileSized"
              :x-small="isMobileSized"
              dark
              class="ml-15"
              @click="
                guibus_publish('dispatch:beacon', {
                  eventId: `welcome-ads_slide_import_products_button-click${
                    isMobileSized ? '-mobile' : ''
                  }`,
                })
                showProductDataSettingsModal = true
              "
              >Import Products</v-btn
            >
            <v-btn
              :class="isMobileSized || mode === 'dynamic' ? 'ml-4' : 'ml-15'"
              color="orange"
              :small="!isMobileSized"
              :x-small="isMobileSized"
              dark
              @click="
                guibus_publish('dispatch:beacon', {
                  eventId: `welcome-ads_slide_browse_solutions-click${
                    isMobileSized ? '-mobile' : ''
                  }`,
                })
                showAllSolutionsModal = true
              "
              >Browse Solutions</v-btn
            >
            <v-btn
              class="expandButton ml-2"
              :class="{ mobileExpandButton: isMobileSized }"
              fab
              rounded
              small
              @click="expandEditor"
            >
              <v-icon v-if="isMobileSized"
                >mdi-{{
                  editorIsExpanded ? 'unfold-less-horizontal' : 'unfold-more-horizontal'
                }}</v-icon
              >
              <v-icon v-else
                >mdi-{{
                  editorIsExpanded ? 'unfold-less-vertical' : 'unfold-more-vertical'
                }}</v-icon
              >
            </v-btn>
          </div>
          <div
            v-if="isLoadingEditor"
            class="editorLoaderWrapper d-flex justify-center align-center"
            style="position: absolute; height: 30%; width: 100%;"
          >
            <v-progress-circular
              :size="150"
              :width="8"
              indeterminate
              color="grey lighten-2"
            ></v-progress-circular>
          </div>
          <div
            id="ace-editor"
            style="overflow: hidden"
            :style="{ height: editorHeight }"
            :data-adacado-dataset="datasetAce"
            @click="handleEditorClick()"
            @touchstart="handleEditorClick()"
          >
            <div v-pre></div>
          </div>
        </div>
      </v-col>
      <div
        class="backNextButtonDisplay d-flex"
        :class="{ mobileBackNextButtonDisplay: isMobileSized }"
      >
        <v-btn
          class="mr-3"
          dark
          color="grey lighten-1"
          @click="
            guibus_publish('dispatch:beacon', {
              eventId: `welcome-ads_slide_back_button-click${isMobileSized ? '-mobile' : ''}`,
            })
            $emit('changeStep', 'solutions')
          "
          >Back</v-btn
        >
        <v-btn class="white--text" color="primary" @click="showLogoWarningModal = true">Next</v-btn>
      </div>
    </v-row>
    <v-dialog
      v-model="showLogoWarningModal"
      :width="isMobileSized ? `${mobileWidth}px` : '500px'"
      persistent
      no-click-animation
    >
      <v-card class="py-3">
        <v-card-title class="headline">Did you upload your logo?</v-card-title>
        <v-card-text class="pb-2">
          A logo is required to serve your ads. Ads without a logo (or something visually
          identifying your brand) will be rejected. Please ensure all your ads have a logo before
          continuing.
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn color="primary" @click="handleCreativesAndContinue">Confirm and Continue</v-btn>
          <v-btn color="grey lighten-1" dark @click="showLogoWarningModal = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showProductDataSettingsModal"
      :width="isMobileSized ? `${mobileWidth}px` : '1024px'"
      persistent
      no-click-animation
    >
      <v-card class="py-3">
        <ProductDataForm
          :isModal="true"
          :advertiser="advertiserData"
          :dataFeedSettingsProps="dataFeedSettings"
          :isFreemium="isFreemium"
          :isMobileSized="isMobileSized"
          @saveAndContinue="handleProductDataSave"
          @closeModal="showProductDataSettingsModal = false"
        />
      </v-card>
    </v-dialog>
    <!-- Campaign Solutions Modal -->
    <ModalWrapper
      v-model="showAllSolutionsModal"
      femsName="campaign-solutions"
      femsVersion="v1"
      :aEvents="campaignSolutionsAEvents"
      :modalDataSet="campaignSolutionsModalDataSet"
      :fromBottom="true"
    />
  </div>
</template>

<script>
import FemsService from 'fems-service'
import EnvService from 'env-service'
import Parameter from 'parameter-mixin'
import StepIcons from '../units/StepIcons.vue'
import CanvasExporter from 'template-html-generator-service/CanvasExporter'
import sortStoryboards from '../modules/sortStoryboards.js'
import ProductDataForm from '../units/ProductDataForm'
import * as STATIC_SOLUTION_OPTIONS from '../configs/staticSolutionOptions'
import * as DYNAMIC_SOLUTION_OPTIONS from '../configs/dynamicSolutionOptions'
import { DELTA_RULES } from '../configs/deltaRules'
import AssetPathServicePackage from 'asset-path-service'
import CreativeInterfaceFactoryNoAuth from 'bs-interface-creative/bs-interface-creative-prelogin'
import CampaignSolutionInterfaceFactoryNoAuth from 'bs-interface-campaign-solution/bs-interface-campaign-solution-prelogin'
import ModalWrapper from 'component-modal-wrapper'

export default {
  mixins: [Parameter],
  components: {
    StepIcons,
    ProductDataForm,
    ModalWrapper,
  },
  props: {
    solutionId: {
      type: Number,
    },
    mode: {
      type: String,
      default: 'static',
    },
    isShopifyUser: {
      type: Boolean,
      default: false,
    },
    vertical: {
      type: String,
      default: 'retail',
    },
    subVertical: {
      type: String,
      default: undefined,
    },
    useCase: {
      type: String,
      default: 'storebrand',
    },
    dataFeedSettingsProps: {
      type: Object,
      default: undefined,
    },
    inventoryItemsProps: {
      type: Array,
      default: undefined,
    },
    storyboardsProps: {
      type: Array,
      default: undefined,
    },
    frameCountProps: {
      type: Number,
      default: 1,
    },
    isQuickStart: {
      type: Boolean,
      default: false,
    },
    isMobileSized: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedSolutionId: this.solutionId,
      currentSolutionId: this.solutionId,
      storyboards: this.storyboardsProps || [],
      selectedTemplate: undefined,
      showEditorModal: false,
      isLoadingCreatives: false,
      currentTemplateIds: [],
      updatedStoryboardIdx: undefined,
      inventoryItems: this.inventoryItemsProps,
      showProductDataSettingsModal: false,
      advertiserData: { Vertical: this.vertical },
      dataFeedSettings: this.dataFeedSettingsProps,
      frameCount: this.frameCountProps,
      isTemplateDirty: false,
      reRenderEditorKey: 0,

      solutionThumbnails: [],
      solutionModalText: 'Select from one of our top performers',
      allSolutionOptions:
        this.mode === 'dynamic'
          ? DYNAMIC_SOLUTION_OPTIONS.default[this.isQuickStart ? 'quickstart' : 'freemium']
          : STATIC_SOLUTION_OPTIONS.default[this.isQuickStart ? 'quickstart' : 'freemium'],
      solutionOptionsForVertical: [],
      isFreemium: !this.isQuickStart,
      isLoadingEditor: true,

      showAllSolutionsModal: false,
      campaignSolutionsAEvents: [
        {
          eventName: 'quickStartSolutionSelectionConfirmation',
          callback: (modalWrapperObj, payload) => {
            // modalWrapper structure returns the modalWrapper object as the first argument and the payload as the second
            // modalWrapper object is not used in this case
            this.guibus_publish('dispatch:beacon', {
              eventId: `welcome-solution_selector_select_library_solution_${
                payload.campaignSolutionId
              }_and_next_button-click${this.isMobileSized ? '-mobile' : ''}`,
            })
            if (payload.adType !== this.mode) {
              this.$emit('changeMode', payload.adType)
            }
            this.handleSolutionSelectionAndClose(payload.campaignSolutionId)
            this.showAllSolutionsModal = false
          },
        },
        {
          eventName: 'cancelCampaignSolutionsModal',
          callback: () => {
            this.showAllSolutionsModal = false
          },
        },
      ],
      editorIsExpanded: false,
      isAdsTextScrolling: false,
      showLogoWarningModal: false,
    }
  },
  async beforeMount() {
    this.guibus_subscribe('change:quickStartStoryboards', this.handleStoryboardsChange)
    this.guibus_subscribe('loaded:aceEditor', this.handleAceEditorLoad)
    if (!this.storyboardsProps?.length) {
      await this.fetchTemplates()
    } else {
      this.$nextTick(() => {
        FemsService.renderChildFems('ace-editor', 'v2')
      })
    }
  },
  beforeDestroy() {
    this.guibus_unsubscribe('change:quickStartStoryboards', this.handleStoryboardsChange)
    this.guibus_unsubscribe('loaded:aceEditor', this.handleAceEditorLoad)
    FemsService.teardownChildFems('ace-editor', 'v2')
  },
  methods: {
    setBrowseSolutionsButtonClass() {
      if (this.isMobileSized) return 'ml-4'
      if (this.mode === 'dynamic') return 'ml-4'
    },
    handleEditorClick() {
      if (this.editorIsExpanded) {
        return
      }
      this.expandEditor()
    },
    handleAceEditorLoad() {
      this.isLoadingEditor = false
    },
    handleCreativesAndContinue() {
      this.guibus_publish('dispatch:beacon', {
        eventId: `welcome-ads_slide_next_button-click${this.isMobileSized ? '-mobile' : ''}`,
      })
      this.$emit('handleCreatives', this.creativesData)
      this.$emit('changeStep', 'advertiser')
    },
    handleStoryboardsChange(storyboards) {
      this.storyboards = storyboards
      this.$emit('handleCreatives', this.creativesData)
    },
    setWidgetValueViaResponse(widget, data) {
      if (typeof widget.value.content === 'string') {
        widget.value.content = data
      } else {
        this._setWidgetContentRPValue(widget, data)
      }
    },
    handleProductDataSave(payload) {
      this.dataFeedSettings = payload.dataFeedSettings
      this.inventoryItems = payload.inventoryItems
      this.showProductDataSettingsModal = false
      this.$emit('handleCreatives', this.creativesData)
      FemsService.teardownChildFems('ace-editor', 'v2')
      this.$nextTick(() => {
        FemsService.renderChildFems('ace-editor', 'v2')
      })
    },
    resetProductData() {
      this.dataFeedSettings = undefined
      this.inventoryItems = undefined
      if (this.mode === 'dynamic') {
        this.currentView = 'productData'
      }
      this.$emit('handleCreatives', this.creativesData)
    },
    resetCreativesData() {
      this.storyboards = []
      this.currentTemplateIds = []
      this.hasInAdCheckout = false
      FemsService.teardownChildFems('ace-editor', 'v2')
    },
    convertWidgetsToWidgetGroups(blueprint) {
      if (!blueprint.widgetGroups) {
        blueprint.widgetGroups = [
          {
            widgets: blueprint.widgets,
            properties: {},
          },
        ]
        delete blueprint.widgets
      }
      return blueprint
    },
    setShadows(event) {
      if (!this.isMobileSized) return
      if (!this.isAdsTextScrolling) {
        window.requestAnimationFrame(() => {
          if (event.target.scrollTop > 0) {
            this.$refs.adsTextContainer.classList.add('off-top')
          } else {
            this.$refs.adsTextContainer.classList.remove('off-top')
          }
          if (event.target.scrollTop < event.target.scrollHeight - event.target.clientHeight) {
            this.$refs.adsTextContainer.classList.add('off-bottom')
          } else {
            this.$refs.adsTextContainer.classList.remove('off-bottom')
          }
          this.isAdsTextScrolling = false
        })
        this.isAdsTextScrolling = true
      }
    },
    async handleSolutionSelectionAndClose(solutionId) {
      this.currentSolutionId = solutionId
      this.showAllSolutionsModal = false
      this.getCampaignSolution()
      await this.fetchTemplates()
      this.$emit('handleCreatives', this.creativesData)
    },
    async getCampaignSolution() {
      if (this.isQuickStart) {
        await this.CampaignSolutionInterface.getCampaignSolution(this.currentSolutionId, r => {
          this.selectedSolution = r
        })
      } else {
        await this.CampaignSolutionInterfaceNoAuth.getCampaignSolution(this.currentSolutionId).then(
          r => {
            this.selectedSolution = r
          }
        )
      }
    },
    async fetchTemplates() {
      this.isLoadingCreatives = true
      this.isLoadingEditor = true
      this.resetCreativesData()
      if (this.isQuickStart) {
        await this.CampaignSolutionInterface.getAllTemplates(this.currentSolutionId, async r => {
          this.handleTemplateFetch(r)
        })
      } else {
        await this.CampaignSolutionInterfaceNoAuth.getAllTemplates(this.currentSolutionId).then(
          r => {
            this.handleTemplateFetch(r)
          }
        )
      }
    },
    async handleTemplateFetch(r) {
      let templatePromiseFuncs = []
      const solutionIdReverseArray = String(this.currentSolutionId)
        .split('')
        .reverse()
      this.frameCount = r[0].templates.length
      r.forEach((storyboard, storyboardIdx) => {
        // only one template will be used to represent all templates and
        // any changes made to this single template will be applied to all templates in that storyboard
        storyboard.templates = storyboard.templates.splice(0, 1)
        storyboard.templates.forEach((template, templateIdx) => {
          const filePath = `solutions/${solutionIdReverseArray.join(
            '/'
          )}/templates/0_${storyboardIdx}_${templateIdx}`
          template.templateId = Date.now() + storyboardIdx * 10 + templateIdx
          template.vertical = this.vertical
          this.currentTemplateIds.push(template.templateId)
          template.blueprint.fontFaceSet.forEach(fontFace => {
            if (fontFace.src?.length && fontFace.src.includes('abstractTemplatePath')) {
              const fileName = fontFace.src.split('/').pop()
              const templatePromiseFunc = () => {
                return new Promise(res => {
                  if (this.isQuickStart) {
                    this.CreativeInterface.copyAssetV3({
                      filePath,
                      fileName,
                      templateID: template.templateId,
                      directory: 'quickstart',
                    }).then(r => {
                      if (r && r.responseData) {
                        fontFace.src = r.responseData
                      }
                      res()
                    })
                  } else {
                    this.CreativeInterfaceNoAuth.copyAssetV4({
                      filePath,
                      fileName,
                      templateID: template.templateId,
                    }).then(r => {
                      if (r) {
                        fontFace.src = r
                      }
                      res()
                    })
                  }
                })
              }
              templatePromiseFuncs.push(templatePromiseFunc)
            }
          })
          template.blueprint = this.convertWidgetsToWidgetGroups(template.blueprint)
          template.blueprint.widgetGroups.forEach(wg => {
            wg.widgets.forEach(w => {
              if (template.width === 300 && template.height === 250) {
                if (w.meta.toolbox.label === 'In-Ad Checkout') {
                  this.hasInAdCheckout = true
                }
              }
              if (w.type === 'image') {
                let fileName
                if (typeof w.value.content == 'object') {
                  fileName = w.value.content.defaultValue.split('/').pop()
                } else {
                  fileName = w.value.content.split('/').pop()
                }
                const templatePromiseFunc = () => {
                  return new Promise(res => {
                    if (this.isQuickStart) {
                      this.CreativeInterface.copyAssetV3({
                        filePath,
                        fileName,
                        templateID: template.templateId,
                        directory: 'quickstart',
                      }).then(r => {
                        if (r && r.responseData) {
                          if (typeof w.value.content == 'object') {
                            w.value.content.defaultValue = r.responseData
                          } else {
                            w.value.content = r.responseData
                          }
                        }
                        res()
                      })
                    } else {
                      this.CreativeInterfaceNoAuth.copyAssetV4({
                        filePath,
                        fileName,
                        templateID: template.templateId,
                      }).then(r => {
                        if (r) {
                          if (typeof w.value.content == 'object') {
                            w.value.content.defaultValue = r
                          } else {
                            w.value.content = r
                          }
                        }
                        res()
                      })
                    }
                  })
                }
                templatePromiseFuncs.push(templatePromiseFunc)
              }
            })
          })
        })
      })
      // if freemium, skip anything other than 300x250 and 728x90 storyboards
      r = r.filter(storyboard => {
        return this.isFreemium
          ? ['300x250', '728x90'].includes(`${storyboard.width}x${storyboard.height}`)
          : true
      })
      while (templatePromiseFuncs.length) {
        await Promise.all(templatePromiseFuncs.splice(0, 9).map(func => func()))
      }
      // upload all assets before generating new html
      // await Promise.all(templatePromises)
      // generate new template htmls
      r.forEach(storyboard => {
        storyboard.templates.forEach(template => {
          template.properties.templateHtml = CanvasExporter.exportAsHTML(template.blueprint, {
            excludeOutofboundContent: true,
            clipImageWidgets: true,
            quickStart: { productCount: this.frameCount },
          })
        })
        storyboard.frameCount = this.frameCount
      })
      this.storyboards = sortStoryboards(r)
      this.isLoadingCreatives = false
      this.setPlaceholderImageFilePaths()
      this.$nextTick(() => {
        FemsService.renderChildFems('ace-editor', 'v2')
      })
    },
    setPlaceholderImageFilePaths() {
      let foundCompanyLogo = false
      let foundImage = false
      let storyboardsCopy = JSON.parse(JSON.stringify(this.storyboards))
      for (const storyboard of storyboardsCopy) {
        for (const template of storyboard.templates) {
          for (const wg of template.blueprint.widgetGroups) {
            for (const w of wg.widgets) {
              if (w.meta.toolbox.label.toLowerCase() == 'company logo') {
                this.placeholderLogoImageSrc = `https://${
                  this.isProductionEnv ? '' : 'staging-'
                }content.adacado.com${w.value.content.defaultValue.replace(
                  '/abstractQuickStartTemplatePath',
                  this.AssetPathService.getQuickStartTemplateAssetPath(template.templateId)
                )}`
                foundCompanyLogo = true
                if (foundImage) return
              }
              if (w.meta.toolbox.label.toLowerCase() == 'image') {
                let filename
                if (typeof w.value.content == 'object') {
                  filename = w.value.content.defaultValue
                } else {
                  filename = w.value.content
                }
                this.placeholderImageSrc = `https://${
                  this.isProductionEnv ? '' : 'staging-'
                }content.adacado.com${filename.replace(
                  '/abstractQuickStartTemplatePath',
                  this.AssetPathService.getQuickStartTemplateAssetPath(template.templateId)
                )}`
                foundImage = true
                if (foundCompanyLogo) return
              }
            }
          }
        }
      }
    },
    // blueprint util functions
    _getWidgetLabel(widget) {
      if (!widget) return undefined

      return widget.meta.toolbox.label
    },
    _setWidgetContentRPValue(widget, newRPValue) {
      // Value of a widget is either an object containing a content property or
      // an array of objects (text) each with their their own content property.
      // Apr 13, 2021 - since blueprint inception, the Array in .value key has always
      // only contained one value as we've never evolved the text type widget
      if (Array.isArray(widget.value)) {
        widget.value[0].content.defaultValue = newRPValue
      } else {
        widget.value.content.defaultValue = newRPValue
      }
    },
    _setWidgetPropertyValue(payload) {
      const { widget, type, delta } = payload
      const { isDeltaChange, property, newValue } = delta
      // setting content needs more checks as the value property it is part of can be
      // either an array or an object (also does not contain any properties that would
      // require delta changes)
      if (type == 'content') {
        this._setWidgetContentPropertyValue(widget, property, newValue)
      } else {
        let propertyPath
        // for nested properties, we need to split the string to get the correct filepath
        if (type.includes('.')) {
          const typeArray = type.split('.')
          propertyPath =
            type == 'config'
              ? widget['value'][type]
              : typeArray.reduce((acc, curr) => {
                  return acc[curr]
                }, widget)
        } else {
          propertyPath = type == 'config' ? widget['value'][type] : widget[type]
        }
        if (isDeltaChange) {
          if (propertyPath[property] === undefined) {
            propertyPath[property] = DELTA_RULES[property].lowerLimit
          }
          propertyPath[property] = propertyPath[property] + newValue
          // do not allow negative values for baseStyle delta changes
          if (type != 'layout' && propertyPath[property] < DELTA_RULES[property].lowerLimit) {
            propertyPath[property] = DELTA_RULES[property].lowerLimit
          }
        } else {
          this.$set(propertyPath, property, newValue)
        }
      }
    },
    _setWidgetContentPropertyValue(widget, property, newValue) {
      // Value of a widget is either an object containing a content property or
      // an array of objects (text) each with their their own content property.
      // Apr 13, 2021 - since blueprint inception, the Array in .value key has always
      // only contained one value as we've never evolved the text type widget
      if (Array.isArray(widget.value)) {
        widget.value[0].content[property] = newValue
      } else {
        widget.value.content[property] = newValue
      }
    },
    _setCommonPropertyValueOfAllWidgetsByLabel(blueprint, payload) {
      let isBlueprintChanged = false
      blueprint.widgetGroups.forEach(wg => {
        wg.widgets.forEach(w => {
          // Set new property value to RP widget
          const label = this._getWidgetLabel(w)
          if (w.id !== payload.widget.id && label === payload.label) {
            this._setWidgetPropertyValue({ ...payload, widget: w })
            isBlueprintChanged = true
          }
          if (w.id === payload.widget.id) {
            isBlueprintChanged = true
          }
        })
      })
      return isBlueprintChanged
    },
    // SET, public - given a widget {object} and url {string}, set the widget.href key
    // if widget is configured to use the url
    //
    // Note that url = null is a valid state and in fact default.  This variable is used to
    // set the widget.href.defaultValue key, which if CSR detects is falsy will inject
    // with advertiser URL
    //
    // @return widget {object}
    _setWidgetHref(widget, url = null) {
      if (!widget) return

      // Do nothing if widget is not supposed to use href, ie isHrefApplied == false
      const isHrefApplied =
        (widget?.meta?.widgetVersion === 1 && widget?.type !== 'navigation') ||
        (widget?.meta?.widgetVersion > 1 && widget?.isHrefApplied)
      if (!isHrefApplied) return

      // Sanity check for widget.href. Some older widgets have href as a string instead of
      // object. Convert these into objects.
      if (widget.href === null || typeof widget.href === 'string') {
        widget.href = this._generateRichPlaceholderForHref(url)
      } else {
        widget.href.defaultValue = url
      }

      return widget
    },
    // FACTORY, public - Return a JSON object representing a rich placeholder for href key
    // of widgets
    //
    // @return richplaceholder {object}
    _generateRichPlaceholderForHref(defaultValue = null) {
      return {
        displayName: 'Webpage Link',
        name: 'productLink',
        type: 'url',
        truncate: null,
        defaultValue,
        inventoryIndex: 0,
        codeType: 'attribute',
      }
    },
    expandEditor() {
      this.editorIsExpanded = !this.editorIsExpanded
      if (this.isMobileSized) {
        document.getElementsByClassName('mobileEditorArea')[0].classList.toggle('expanded')
        return
      }
      if (this.editorIsExpanded) {
        document.getElementsByClassName('desktopAdsTextContent')[0].classList.toggle('expanded')
        setTimeout(() => {
          document.getElementsByClassName('desktopAdsTextContent')[0].classList.toggle('hidden')
        }, 500)
        if (!this.$firebaseUser) {
          document.getElementsByClassName('adacadoTerms')[0].style.color = 'white'
        }
      } else {
        document.getElementsByClassName('desktopAdsTextContent')[0].classList.toggle('hidden')
        setTimeout(() => {
          document.getElementsByClassName('desktopAdsTextContent')[0].classList.toggle('expanded')
        }, 1)
        if (!this.$firebaseUser) {
          document.getElementsByClassName('adacadoTerms')[0].style.color = 'black'
        }
      }
    },
  },
  computed: {
    editorHeight() {
      let value = 'calc('
      if (this.isMobileSized && !this.editorIsExpanded) {
        value += '55vh - '
      } else {
        value += '100vh - '
      }
      value += this.isQuickStart || this.isMobileSized ? '200px' : '152px'
      return value
    },
    mobileWidth() {
      return window.innerWidth
    },
    creativesData() {
      return {
        dataFeedSettings: this.dataFeedSettings,
        inventoryItems: this.inventoryItems,
        storyboards: this.storyboards,
        selectedSolutionId: this.currentSolutionId,
        frameCount: this.frameCount,
      }
    },
    datasetAce() {
      return this.$constructAdacadoDataset({
        MODE: 'simple',
        quickStartInventoryItems: this.inventoryItems,
        productCount: this.frameCount,
        storyboards: this.storyboards,
        adType: this.mode,
        isFreemium: this.isFreemium,
        vertical: this.vertical,
      })
    },
    campaignSolutionsModalDataSet() {
      return {
        isPersistent: true,
        noClickAnimation: true,
        width: 1100,
        isModal: true,
        isQuickStart: true,
        isShopifyQuickstartUser: this.isShopifyUser,
        vertical: this.vertical,
        subVertical: this.subVertical,
        mode: this.mode,
      }
    },
    AssetPathService() {
      return window.adacado.bscs ? window.adacado.bscs.AssetPathService : AssetPathServicePackage
    },
    CampaignSolutionInterface() {
      return window.adacado.bscs
        ? window.adacado.bscs.CampaignSolutionInterfaceFactory()
        : undefined
    },
    CampaignSolutionInterfaceNoAuth() {
      return CampaignSolutionInterfaceFactoryNoAuth()
    },
    CreativeInterface() {
      return window.adacado.bscs ? window.adacado.bscs.CreativeInterfaceFactory() : undefined
    },
    CreativeInterfaceNoAuth() {
      return CreativeInterfaceFactoryNoAuth()
    },
    AdvertiserInterface() {
      return window.adacado.bscs ? window.adacado.bscs.AdvertiserInterfaceFactory() : undefined
    },
    isProductionEnv() {
      return EnvService.IS_PRODUCTION_CONNECTION
    },
  },
}
</script>

<style>
/*
vuetify dialog hack: does not work in scoped style
which is why it's in its own style tag here
*/
.solutionSelectionModalWrapper {
  min-width: 1000px;
}
</style>

<style lang="scss" scoped>
.adsContainer {
  width: 100vw;
  height: 100%;
  .adsContent {
    display: flex;
    height: 100%;
    position: relative;
    width: 100%;
    margin: auto;
    align-items: center;
    &.mobileAdsContent {
      height: unset;
    }
    .adsList {
      height: calc(100vh - 108px);
      overflow: auto;
    }
    .adsTextContainer {
      overflow: hidden;
      position: relative;
      .shadow {
        bottom: 0;
        left: 0;
        pointer-events: none;
        position: absolute;
        right: 0;
        top: 0;
        transition: all 0.2s ease-out;
      }
      &.off-top {
        .shadow-top {
          box-shadow: 0 1em 1em -1em black inset;
        }
      }
      &.off-bottom {
        .shadow-bottom {
          box-shadow: 0 -1em 1em -1em black inset;
        }
      }
      .adsText {
        &::-webkit-scrollbar {
          width: 12px;
          height: 12px;
        }

        &::-webkit-scrollbar-track {
          background: #e6e6e6;
          border-left: 1px solid #dadada;
        }

        &::-webkit-scrollbar-thumb {
          background: #b0b0b0;
          border: solid 3px #e6e6e6;
          border-radius: 7px;
        }
      }
    }
    .adsList {
      &::-webkit-scrollbar {
        width: 12px;
        height: 12px;
      }

      &::-webkit-scrollbar-track {
        background: #e6e6e6;
        border-left: 1px solid #dadada;
      }

      &::-webkit-scrollbar-thumb {
        background: #b0b0b0;
        border: solid 3px #e6e6e6;
        border-radius: 7px;
      }
    }
  }
}
.adsTitle {
  &.mobileTitle {
    font-size: 1.5rem !important;
  }
}
.backNextButtonDisplay {
  position: absolute;
  bottom: 32px;
  right: 140px;
  &.mobileBackNextButtonDisplay {
    position: fixed;
    bottom: 90px;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    z-index: 10;
  }
}
.editorArea {
  padding-left: 0;
  background-color: rgb(94, 0, 235);
  position: relative;
  min-width: 800px;
  height: 100%;
  &.mobileEditorArea {
    padding-right: 0;
    position: fixed;
    bottom: 148px;
    height: calc(45vh - 148px);
    transition: all 0.25s linear;
    z-index: 3;
    &.expanded {
      height: calc(100% - 148px);
    }
  }
}

#ace-editor {
  transition: all 0.25s linear;
}

.desktopAdsTextContent {
  transition: all 0.25s linear;
  &.expanded {
    visibility: hidden;
    max-width: 0 !important;
  }
  &.hidden {
    display: none !important;
  }
}

.expandButton {
  position: absolute;
  bottom: -5px;
  &.mobileExpandButton {
    right: 12px;
    bottom: -10px !important;
  }
}

.templateThumbnail {
  max-width: 100%;
  height: auto;
  padding-left: 12px;
  padding-right: 12px;
}
.editorBlock {
  position: absolute;
  z-index: 1;
  cursor: pointer;
}
.solutionSelectionModal,
.mediaSelectorModal {
  background: white;
}
</style>
